import React from 'react';
import { ArticleListSection, ArticleStub } from 'shared-types';

interface ArticleListEditorProps {
    section: ArticleListSection;
    onChange: (newSection: ArticleListSection) => void;
}

const ArticleListEditor: React.FC<ArticleListEditorProps> = ({ section, onChange }) => {

    const handleTitleChange = (newTitle: string) => {
        onChange({ ...section, content: { ...section.content, title: newTitle } });
    };
    
    const handleArticleChange = (index: number, field: keyof ArticleStub, value: string) => {
        const newArticles = [...section.content.articles];
        const articleToUpdate = { ...newArticles[index], [field]: value };
        newArticles[index] = articleToUpdate;
        onChange({ ...section, content: { ...section.content, articles: newArticles } });
    };
    
    const handleAddArticle = () => {
        const newArticle: ArticleStub = { id: `article_${Date.now()}`, title: 'New Article', excerpt: 'A brief summary...', imageUrl: 'https://via.placeholder.com/400x200', link: '#' };
        const newArticles = [...section.content.articles, newArticle];
        onChange({ ...section, content: { ...section.content, articles: newArticles } });
    };

    const handleRemoveArticle = (index: number) => {
        const newArticles = section.content.articles.filter((_, i) => i !== index);
        onChange({ ...section, content: { ...section.content, articles: newArticles } });
    };

    return (
        <div className="space-y-4">
            <div>
                <label className="text-sm font-medium text-slate-600 dark:text-slate-400">Section Title</label>
                <input type="text" value={section.content.title} onChange={e => handleTitleChange(e.target.value)} className="w-full bg-white dark:bg-slate-700 border border-slate-300 dark:border-slate-600 rounded-md p-2 text-sm mt-1" />
            </div>
            <div className="space-y-3">
                {section.content.articles.map((article, index) => (
                    <div key={article.id} className="p-3 bg-slate-100 dark:bg-slate-700/50 rounded-md border border-slate-200 dark:border-slate-600/50">
                        <div className="flex justify-end mb-2">
                            <button onClick={() => handleRemoveArticle(index)} className="px-2 py-1 bg-red-100 text-red-700 dark:bg-red-900/40 dark:text-red-300 text-xs font-semibold rounded-md hover:bg-red-200 dark:hover:bg-red-900/60 transition">Remove Article</button>
                        </div>
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                            <div><label className="text-xs font-medium text-slate-500">Title</label><input type="text" value={article.title} onChange={e => handleArticleChange(index, 'title', e.target.value)} className="w-full bg-white dark:bg-slate-700 border border-slate-300 dark:border-slate-600 rounded-md p-2 text-sm mt-1" /></div>
                            <div><label className="text-xs font-medium text-slate-500">Image URL</label><input type="text" value={article.imageUrl} onChange={e => handleArticleChange(index, 'imageUrl', e.target.value)} className="w-full bg-white dark:bg-slate-700 border border-slate-300 dark:border-slate-600 rounded-md p-2 text-sm mt-1" /></div>
                        </div>
                        <div className="mt-2"><label className="text-xs font-medium text-slate-500">Excerpt</label><textarea value={article.excerpt} onChange={e => handleArticleChange(index, 'excerpt', e.target.value)} rows={2} className="w-full bg-white dark:bg-slate-700 border border-slate-300 dark:border-slate-600 rounded-md p-2 text-sm mt-1 resize-none" /></div>
                        <div className="mt-2"><label className="text-xs font-medium text-slate-500">Link</label><input type="text" value={article.link} onChange={e => handleArticleChange(index, 'link', e.target.value)} className="w-full bg-white dark:bg-slate-700 border border-slate-300 dark:border-slate-600 rounded-md p-2 text-sm mt-1" /></div>
                    </div>
                ))}
            </div>
            <button onClick={handleAddArticle} className="px-3 py-1.5 bg-cyan-100 text-cyan-800 dark:bg-cyan-900/40 dark:text-cyan-300 text-xs font-semibold rounded-full hover:bg-cyan-200 dark:hover:bg-cyan-900/60 transition">+ Add Article</button>
        </div>
    );
};

export default ArticleListEditor;